import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import {
  LayoutDashboard, FileText, GitBranch, Bookmark,
  Bell, UserCircle2, Settings, CreditCard, LogOut, Check, Coins, Radar, UserCog
} from "lucide-react";

const NAV = [
  { to: "/app/dashboard",       label: "Dashboard",       icon: LayoutDashboard },
  { to: "/app/opportunities",   label: "All notices",     icon: FileText },
  { to: "/app/pipeline",        label: "Pipeline",        icon: GitBranch },
  { to: "/app/funding",         label: "Funding",         icon: Coins },
  { to: "/app/radar",           label: "Policy Radar",    icon: Radar },
  { to: "/app/tracked",         label: "Tracked",         icon: Bookmark },
  { to: "/app/alerts",          label: "Alerts",          icon: Bell },
];
const ACCOUNT = [
  { to: "/app/profile",  label: "Company Profile", icon: UserCircle2 },
  { to: "/app/account",  label: "My Account",      icon: UserCog },
  { to: "/app/settings", label: "Team & Settings", icon: Settings },
  { to: "/app/billing",  label: "Billing",         icon: CreditCard },
];

export default function Sidebar() {
  const { user, activeCompany, companies, switchCompany, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate("/login"); };

  return (
    <aside className="sidebar" data-testid="sidebar">
      <div className="sidebar-brand">
        <span className="sidebar-brand-mark" />
        <span>Parapet</span>
      </div>

      {companies?.length > 0 && (
        <div className="mb-2">
          <div className="sidebar-section">Workspace</div>
          {companies.map((c) => (
            <button
              key={c.id}
              onClick={() => switchCompany(c.id)}
              className="sidebar-link w-full text-left"
              style={{
                background: c.id === activeCompany?.id ? "#FFFFFF" : "transparent",
                border: c.id === activeCompany?.id ? "1px solid #E2E2E2" : "1px solid transparent",
                color: "#111111",
              }}
              data-testid={`sidebar-workspace-${c.slug}`}
            >
              <span style={{
                width: 18, height: 18, borderRadius: 3,
                background: "#111", color: "#fff", fontSize: 10,
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                fontWeight: 600,
              }}>
                {c.name.slice(0, 1).toUpperCase()}
              </span>
              <span className="flex-1 truncate text-[13px]">{c.name}</span>
              {c.id === activeCompany?.id && <Check size={14} />}
            </button>
          ))}
        </div>
      )}

      <div className="sidebar-section">Workspace</div>
      {NAV.map((n) => (
        <NavLink key={n.to} to={n.to} className={({ isActive }) => "sidebar-link" + (isActive ? " active" : "")} data-testid={`sidebar-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
          <n.icon size={16} />
          <span>{n.label}</span>
        </NavLink>
      ))}

      <div className="sidebar-section">Account</div>
      {ACCOUNT.map((n) => (
        <NavLink key={n.to} to={n.to} className={({ isActive }) => "sidebar-link" + (isActive ? " active" : "")} data-testid={`sidebar-link-${n.label.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and")}`}>
          <n.icon size={16} />
          <span>{n.label}</span>
        </NavLink>
      ))}

      <div className="mt-auto pt-4 border-t" style={{ borderColor: "var(--parapet-border)" }}>
        <div className="flex items-center gap-2 px-2 py-2">
          <div style={{
            width: 28, height: 28, borderRadius: 4,
            background: "#111", color: "#fff", fontSize: 11,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            {(user?.full_name || user?.email || "U").slice(0, 1).toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[13px] font-medium truncate">{user?.full_name || "User"}</div>
            <div className="text-[11px] truncate" style={{ color: "var(--parapet-text-secondary)" }}>{user?.email}</div>
          </div>
          <button onClick={handleLogout} className="btn-ghost" aria-label="Sign out" data-testid="logout-button">
            <LogOut size={14} />
          </button>
        </div>
      </div>
    </aside>
  );
}
